<template>
  <div class="CardOrder cardOrder" :class="{ 'card-highlight': isActive }" @click="cardClick">
    <slot name="cardHeader"></slot>
    <slot name="cardBody"></slot>
    <slot name="cardFooter"></slot>
  </div>
</template>

<script>
export default {
  name: "CardOrder",
  data() {
    return {}
  },
  props: {
    isActive: Boolean,
  },
  methods: {
    cardClick() {
      this.$emit("cardClick")
    },
  },
}
</script>

<style scoped></style>
